module.exports = __webpack_public_path__ + "static/media/icon_gallery.85cedde0.svg";